import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { endpoints } from "../../../../../../../core/defaultValues";
import { clientQuery } from "../../../../../../../core/data/GraphQLApi";
import { ExceptionManager } from "../../../../../../../core/logManager";

const INIT_STATE = {
    open: false,
    loading: false,

    loadingAssetSubtypes: false,
    assetSubtypes: [],

    loadingEntityLists: false,
    entityLists: []
};

const assetSearchEntityLists = createAsyncThunk(
    "workOrders/asset/advancedFilters/searchEntityLists",
    async ({ limit = 1000, offset = 0 }, { rejectWithValue }) => {
        try {
            const response = await clientQuery(
                assetSearchEntityLists.query,
                {
                    conditions: [{
                        fields: ["entityName"],
                        terms: ["AssetType", "InspectionDeviceType"]
                    }],
                    sort: {
                        field: "entityName",
                        order: "ASC"
                    },
                    limit,
                    offset,
                },
                endpoints.GRAPHQL_GENERAL_V2
            );

            return response?.data || { items: [], total: 0 };
        } catch (exc) {
            ExceptionManager(exc, route, "searchEntityLists");
            return rejectWithValue(exc);
        }
    }
);

const assetSearchAssetSubtype = createAsyncThunk(
    "workOrders/asset/advancedFilters/searchAssetSubtype",
    async ({ limit = 1000, offset = 0 }, { rejectWithValue }) => {
        try {
            const response = await clientQuery(
                assetSearchAssetSubtype.query,
                {
                    conditions: [],
                    sort: {
                        field: "name",
                        order: "ASC"
                    },
                    limit,
                    offset,
                },
                endpoints.GRAPHQL_GENERAL_V2
            );

            return response?.data || { items: [], total: 0 };
        } catch (exc) {
            ExceptionManager(exc, route, "searchAssetSubtype");
            return rejectWithValue(exc);
        }
    }
);

assetSearchAssetSubtype.query = `
    query ($conditions: [AssetSubtypeSearchInput], $sort: [AssetSubtypeSortInput], $limit: Int, $offset: Int) {
        data: searchAssetSubtypes(
            conditions: $conditions
            sort: $sort
            limit: $limit
            offset: $offset
        ) {
            total
            items {
                id
                name
            }
        }
    }
`

assetSearchEntityLists.query = `
    query ($conditions: [EntityListSearchInput], $sort: [EntityListSortInput], $limit: Int, $offset: Int) {
        data: searchEntityLists(
            conditions: $conditions
            sort: $sort
            limit: $limit
            offset: $offset
        ) {
            total
            items {
                entityId
                entityName
                parentId
                label
                value1
                value2
            }
        }
    }
`;

export { assetSearchEntityLists, assetSearchAssetSubtype };

//Slice
const manageAssetAdvancedFiltersRedux = createSlice({
    name: "manage/asset/advancedFilters",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        },
        openModalAssetAdvancedFilters: (state, action) => {
            state.open = action.payload.open;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //assetSearchEntityLists
        builder.addCase(assetSearchEntityLists.pending, (state) => {
            state.loadingEntityLists = true;
        });
        builder.addCase(assetSearchEntityLists.fulfilled, (state, action) => {
            state.loadingEntityLists = false;
            state.entityLists = action.payload.items;
        });
        builder.addCase(assetSearchEntityLists.rejected, (state, action) => {
            state.loadingEntityLists = false;
            state.error = action.payload;
        });

        //assetSearchAssetSubtype
        builder.addCase(assetSearchAssetSubtype.pending, (state) => {
            state.loadingAssetSubtypes = true;
        });
        builder.addCase(assetSearchAssetSubtype.fulfilled, (state, action) => {
            state.loadingAssetSubtypes = false;
            state.assetSubtypes = action.payload.items;
        });
        builder.addCase(assetSearchAssetSubtype.rejected, (state, action) => {
            state.loadingAssetSubtypes = false;
            state.error = action.payload;
        });
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageAssetAdvancedFiltersRedux;

// Extract and export each action creator by name
export const { openModalAssetAdvancedFilters, reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
